import { XMarkIcon } from '@heroicons/react/24/outline'
import React from 'react'
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastProvider";
import { useEffect, useState } from 'react';
import Select from "react-select";

const QuotationDiscussion = ({ close, idCrypt }) => {
    const [discussion, setDiscussion] = useState({
        message: "",
        quotation_id: "",
        status: "",
        next_followup_date: "",
        quotation_loss_reason_id: "",
        worker_tally_id: "",
    })
    const { triggerToast } = useToast();
    const [conversationData, setConversationData] = useState([]);
    const [lossReason, setLossReason] = useState([]);
    const [status, setStatus] = useState([]);
    const [showLossReason, setShowLossReason] = useState(false);
    const [requiredFields, setRequiredFields] = useState({});
    const [quotationsData, setQuotationsData] = useState({});

    //   const isDisabled = leadDatas.lead_status === "loss";
    const isDisabled = discussion.lead_status === "loss";
    const disabledClass = "bg-gray-100 text-gray-500 cursor-not-allowed";
    const handleDiscussionChange = (e) => {
        const { name, value } = e.target;
        if (name == "status" && value === "3. Lost") {
            setShowLossReason(true);
        }
        if (name == "status" && (value === "2. Follow-up" || value === "1. Win")) {
            setShowLossReason(false);
        }
        setDiscussion((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const navigate = useNavigate();

    const fetchDiscussion = async () => {
        try {
            const response = await axios.get(`public/api/quotations/get-discussion/${idCrypt}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "token"
                        )}`,
                    },
                }
            )

            const lossReasonResponse = await axios.get(
                `public/api/quotation-loss-reasons/list`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            setLossReason(lossReasonResponse.data);

            setConversationData(response?.data?.data);
            setQuotationsData(response?.data?.quotation);

        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            } else {
                triggerToast("error", error.response?.data?.message, "error");
            }
        }
    }

    useEffect(() => {
        fetchDiscussion();
    }, [])

    const handleSubmitDiscussion = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`public/api/quotations/discussion/${idCrypt}`,
                discussion,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            "token"
                        )}`,
                    },
                }
            )
            triggerToast(response?.data?.message);
            setDiscussion({
                message: "",
                quotation_id: "",
                status: "",
                next_followup_date: "",
                quotation_loss_reason_id: "",
                worker_tally_id: "",
            });
            fetchDiscussion();
        } catch (error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem("token");
                navigate("/crm/");
            } else {
                setRequiredFields(error.response.data.errors);
            }
        }
    }
    return (
        <div>
            <div className="flex items-center justify-between p-4 border border-gray-200 rounded-t-md">
                <h3 className="text-lg sm:text-md font-semibold text-blue-800">
                    Quotation Follow Up
                </h3>
                <XMarkIcon
                    onClick={close}
                    className="h-8 w-8 cursor-pointer bg-red-600 rounded-full text-white p-2"
                />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 p-4  border  border-gray-200 rounded-b-md">
                <div className="md:col-span-2 space-y-2">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">
                            Party Name
                        </label>
                        <p className="mt-1 font-medium text-blue-700">
                            {/* {leadDatas.customer_name ?? "N/A"} */}
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {discussion?.status === "2. Follow-up" && (
                            <div className="mt-4">
                                <label className="block text-sm font-medium text-gray-700">
                                    Follow Up Note
                                    <span className="text-red-500">*</span>
                                </label>
                                <textarea
                                    name="message"
                                    value={discussion.message}
                                    onChange={handleDiscussionChange}
                                    className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                                        }`}
                                    rows={4}
                                    placeholder="Write follow-up note..."
                                    disabled={isDisabled}
                                />
                                {requiredFields && (
                                    <p className="text-red-500 text-xs mt-1">
                                        {requiredFields.message}
                                    </p>
                                )}
                            </div>
                        )}

                        <div className="mt-4">
                            <div className="mb-2">
                                <div className="w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Select Status
                                    </label>
                                    <select
                                        name="status"
                                        value={discussion.status}
                                        onChange={handleDiscussionChange}
                                        className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                                            }`}
                                        disabled={isDisabled}
                                    >
                                        <option value="">Select Status</option>
                                        <option value="1. Win">1. Win</option>
                                        <option value="2. Follow-up">2. Follow-up</option>
                                        <option value="3. Lost">3. Lost</option>
                                        {/* <option value="4. Negotiation">4.Negotiation</option> */}
                                    </select>
                                    {requiredFields && (
                                        <p className="text-red-500 text-xs mt-1">
                                            {requiredFields.status}
                                        </p>
                                    )}
                                </div>

                                {/* Show only if status = followup */}
                                {discussion.status === "2. Follow-up" && (
                                    <div className="w-full mt-4">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Next Follow Up Date
                                        </label>
                                        <input
                                            type="date"
                                            name="next_followup_date"
                                            value={discussion.next_followup_date}
                                            onChange={handleDiscussionChange}
                                            className={`mt-1 w-full border border-gray-300 rounded px-3 py-2 ${isDisabled ? disabledClass : ""
                                                }`}
                                            disabled={isDisabled}
                                        />
                                        {requiredFields && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {requiredFields.next_followup_date}
                                            </p>
                                        )}
                                    </div>
                                )}

                                {showLossReason && (
                                    <div className="w-full mt-4">
                                        <label className="block text-sm font-medium text-gray-700">
                                            Lost Reason
                                            <span className="text-red-600"> *</span>
                                        </label>
                                        <Select
                                            name="quotation_loss_reason_id"
                                            options={lossReason?.map((reason) => ({
                                                value: reason.id,
                                                label: reason.reason,
                                            }))}
                                            value={
                                                lossReason
                                                    ?.map((reason) => ({
                                                        value: reason.id,
                                                        label: reason.reason,
                                                    }))
                                                    .find(
                                                        (reason) =>
                                                            reason.value == discussion?.quotation_loss_reason_id
                                                    ) || null
                                            }
                                            onChange={(selectedOption) =>
                                                handleDiscussionChange({
                                                    target: {
                                                        name: "quotation_loss_reason_id",
                                                        value: selectedOption?.value || "",
                                                        worker: selectedOption?.label || "",
                                                    },
                                                })
                                            }
                                            isMulti={false}
                                            placeholder="Select Loss Reason"
                                            className="mt-1"
                                            classNamePrefix="select"
                                        />
                                        {requiredFields && (
                                            <p className="text-red-500 text-xs mt-1">
                                                {requiredFields.quotation_loss_reason_id}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>

                            <button
                                onClick={handleSubmitDiscussion}
                                className="mt-4 bg-blue-600 text-white w-full md:w-auto flex justify-center font-medium px-6 py-2 rounded-md hover:bg-blue-700"
                            >
                                Update Lead
                            </button>
                        </div>
                    </div>



                    {/* FOLLOW UP HISTORY */}
                    <div className="border sm:border-0 p-3 rounded-md sm:rounded-none p-0 mx-auto">
                        <h4 className="inline-block text-sm font-semibold bg-blue-100 text-blue-800 px-3 py-1 rounded shadow-sm">
                            Follow Up's
                        </h4>

                        {conversationData.length > 0 ? (
                            <div className="space-y-4 mt-2 h-[300px] overflow-y-scroll">
                                {conversationData.map((item, index) => (
                                    <div key={index} className="space-y-1">
                                        {/* Worker Tally ID and Status in same row */}
                                        <div className="flex justify-between text-xs font-semibold text-gray-600">
                                            <p>{item.worker_tally_id}</p>
                                            <p>
                                                Status :{" "}
                                                {item.status?.charAt(0).toUpperCase() +
                                                    item.status?.slice(1)}
                                            </p>
                                        </div>

                                        {/* Message Bubble */}
                                        <div className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg ">
                                            {item.message}
                                        </div>

                                        {/* Dates in same row */}
                                        <div className="flex justify-end">
                                            <div className=" text-xs text-gray-500 ">
                                                <p>
                                                    <mark className="bg-white">
                                                        Next Follow Up :
                                                    </mark>{" "}
                                                    {item.next_followup_date}
                                                </p>
                                                <p className="mt-2 text-right">
                                                    <mark className="bg-white text-right">
                                                        Posted :
                                                    </mark>{" "}
                                                    {item.created_at.split("T")[0]}
                                                </p>
                                                {/* <p className="text-right">{item.created_at.split("T")[0]}</p> */}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="space-y-4">
                                <div className="max-w-xs">
                                    <p className="text-xs font-semibold text-gray-600 mb-1 mt-4">
                                        No Conversation Found
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="bg-gray-50 border rounded-md p-4 shadow-sm space-y-3 text-sm text-gray-800">
                    {quotationsData ? (
                        <div className="bg-gray-50 space-y-3 text-sm text-gray-800 mb-4">
                            {/* Customer Name */}
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-xs text-gray-600 min-w-[100px]">
                                    <span>👤</span>
                                    <span>Party Name</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[70%]">
                                    {quotationsData?.party_name ?? "N/A"}
                                </div>
                            </div>

                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📋</span>
                                    <span>Quote Date</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">

                                    {quotationsData.quote_date
                                        ? new Date(
                                            quotationsData.quote_date
                                        ).toLocaleDateString("en-GB") // dd/mm/yyyy
                                        : "N/A"}
                                </div>
                            </div>

                            {/* Phone */}
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📋</span>
                                    <span>Enquiry No</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData?.enquiry_no ?? "N/A"}
                                </div>
                            </div>



                            {/* Type of Work */}
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📁</span>
                                    <span>Type of Work</span>
                                </div>

                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData?.type_of_work ?? "N/A"}
                                </div>
                            </div>

                            {/* Sales/Service */}
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>🔗</span>
                                    <span>Sales/Service</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.sales_service ?? "N/A"}
                                </div>
                            </div>



                            {/* Sales Man */}
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>✅</span>
                                    <span>Sales Man</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.sales_person ?? "N/A"}
                                </div>
                            </div>

                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📆</span>
                                    <span>1st Followup Date</span>
                                </div>
                                {/* <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                            {leadDatas.followup_date ?? "N/A"}
                          </div> */}
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.followup_date
                                        ? new Date(
                                            quotationsData.followup_date
                                        ).toLocaleDateString("en-GB") // dd/mm/yyyy
                                        : "N/A"}
                                </div>
                            </div>

                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📆</span>
                                    <span>Next Followup Date</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {/* {leadDatas.next_followup_date ?? "N/A"} */}
                                    {quotationsData.next_followup_date
                                        ? new Date(
                                            quotationsData.next_followup_date
                                        ).toLocaleDateString("en-GB") // dd/mm/yyyy
                                        : "N/A"}
                                </div>
                            </div>

                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>⌛</span>
                                    <span>Quotation  Status</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.status ?? "N/A"}
                                </div>
                            </div>
                            <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>⌛</span>
                                    <span>Quotation Send Status</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.quote_sent_status?.charAt(0).toUpperCase() +
                                        quotationsData.quote_sent_status?.slice(1) ?? "N/A"}
                                </div>
                            </div>






                            {/* Contact No */}
                            {/* <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📞</span>
                                    <span>Contact No</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.contact_person_no ?? "N/A"}
                                </div>
                            </div> */}

                            {/* Address */}
                            {/* <div className="flex justify-between border-b pb-3">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>📍</span>
                                    <span>Address</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.address ?? "N/A"}
                                </div>
                            </div> */}

                            {/* <div className="flex justify-between">
                                <div className="flex items-start gap-2 font-medium text-gray-600 text-xs min-w-[100px]">
                                    <span>💬</span>
                                    <span>Comments</span>
                                </div>
                                <div className="text-right font-semibold text-xs text-gray-800 max-w-[60%]">
                                    {quotationsData.comments ?? "N/A"}
                                </div>
                            </div> */}
                        </div>
                    ) : (
                        <div className="text-center text-gray-600">
                            No lead data found.
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}

export default QuotationDiscussion